import React, { useState } from "react";
import { Box, Button, Divider, Stack, Typography, TextField, InputAdornment } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { discountGroupObjects } from "../data";

function DiscountValueSection({ value, setValue }) {
	const [discounts, setDiscounts] = useState(value.discount_value || []);

	const columns = [
		{
			field: "buy",
			headerName: "BUY Value",
			editable: true,
			type: "number",
			align: "center",
			headerAlign: "center",
			flex: 1,
		},
		{
			field: "get",
			headerName: "GET Value",
			editable: true,
			type: "number",
			align: "center",
			headerAlign: "center",
			flex: 1,
		},
		{
			field: "actions",
			headerName: "Actions",
			sortable: false,
			filterable: false,
			renderCell: (params) => (
				<Button variant="outlined" color="error" size="small" onClick={() => handleDeleteRow(params.row.id)}>
					Delete
				</Button>
			),
			width: 100,
			align: "center",
			headerAlign: "center",
		},
	];

	const handleAddRow = () => {
		const newId = discounts.length ? discounts[discounts.length - 1].id + 1 : 1;
		const newRow = { id: newId, buy: 0, get: 0 };
		const updated = [...discounts, newRow];
		setDiscounts(updated);
		setValue((prev) => ({ ...prev, discount_value: updated }));
	};

	const handleDeleteRow = (idToDelete) => {
		const updated = discounts.filter((row) => row.id !== idToDelete);
		setDiscounts(updated);
		setValue((prev) => ({ ...prev, discount_value: updated }));
	};

	const handleRowUpdate = (newRow) => {
		const updatedRows = discounts.map((row) => (row.id === newRow.id ? { ...row, buy: newRow.buy, get: newRow.get } : row));

		setDiscounts(updatedRows);
		setValue((prev) => ({
			...prev,
			discount_value: updatedRows,
		}));

		return newRow; // required by DataGrid
	};

	const handleSingleFieldChange = (e) => {
		console.log("first", e.target.value);
		setValue((prev) => ({
			...prev,
			discount_value: {
				...prev.discount_value,
				[value.scheme_type === "Flat_Discount_Percent" ? "percent" : "value"]: e.target.value,
			},
		}));
	};

	const renderContent = () => {
		if (value[discountGroupObjects.general_information.key]?.scheme_type === "Flat_Discount_Percent") {
			return (
				<TextField
					fullWidth
					label="Flat % Discount"
					type="number"
					value={value.discount_value?.percent}
					onChange={handleSingleFieldChange}
					InputProps={{
						endAdornment: <InputAdornment position="end">%</InputAdornment>,
					}}
				/>
			);
		} else if (value[discountGroupObjects.general_information.key]?.scheme_type === "Flat_Discount_Value") {
			return (
				<TextField
					fullWidth
					label="Flat ₹ Discount"
					type="number"
					value={value.discount_value?.value || ""}
					onChange={handleSingleFieldChange}
					InputProps={{
						endAdornment: <InputAdornment position="end">₹</InputAdornment>,
					}}
				/>
			);
		} else {
			return (
				<>
					<Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
						<Typography variant="h6">Scheme Discount Slab</Typography>
						<Button variant="contained" onClick={handleAddRow}>
							Add Row
						</Button>
					</Stack>
					<Divider sx={{ mb: 2 }} />
					<DataGrid
						rows={discounts}
						columns={columns}
						disableColumnMenu
						hideFooter
						processRowUpdate={handleRowUpdate}
						experimentalFeatures={{ newEditingApi: true }}
					/>
				</>
			);
		}
	};

	return (
		<Box width="95%" p={3}>
			<Typography variant="h6" mb={2}>
				Discount Value
			</Typography>
			{renderContent()}
		</Box>
	);
}

export default DiscountValueSection;
